var x_listeners = function () { };

x_listeners.prototype = {
	init: function () {
		var me = this;
		$(function () {

			me.elements();
			me.forms();
			me.modals();
			me.tooltips();
			xcontrols.init();

			$('div.xgrid:not(.xgrid_initialized)').each(function (i, el) {
				new xgrid().init($(el));
			});

			$('table.xgrid:not(.xgrid_initialized)').each(function (i, el) {
				new xtable().init($(el));
			});

			$(window).off('popstate').on('popstate', function (e) {
				// handlina histoy back
				e.preventDefault();
				// bug -  nepereina atgal daugiau nei 1 state
				var url = location.pathname + (location.search ? location.search : ''); // gal geriau imti location.href
				xhelper.content.load(url, null);
			});
		});

		return me;
	},
	ajax: function (target) {
		var me = this;

		xcontrols.init();
		me.forms(); // reikia init formas, kai pakraunama per xhelper.contrent.load()
		me.modals();

		$('div.xgrid:not(.xgrid_initialized)').each(function (i, el) {
			new xgrid().init($(el));
		});

		return me;
	},
	modals: function () {
		var me = this;

		$('a[data-modal]').off('click');
		$('a[data-modal]').click(function (e) {
			e.preventDefault();

			var a = $(this),
				modal = a.data('modal'),
				module = a.data('module'),
				title = a.data('title'),
				fk = a.data('fk'),
				pk = a.data('pk'),
				post = a.data('post'),
				form = a.closest('form'),
				width = a.data('width') || 'lg';

			if (a.data('condition')) {
				var fn = window[a.data('condition')]
				if (typeof fn === 'function' && !fn()) return;
			}


			loadingbar.start();

			if (a.data('dataset')) {
				if (post === undefined) {
					post = {};
				}
				post.checked = $('.xgrid[data-dataset=' + a.data('dataset') + ']')[0].xgrid.getCheckedValues();
			}

			xdialog.modal.show({
				title: title,
				//modal: modal,
				module: module,
				pk: pk,
				fk: fk,
				post: post,
				width: width
			}, modal);
		});
		//neaiski vieta
		$(document).on('shown.bs.modal', function () {
			xcontrols.init();
			me.tooltips();
			var modal = $('.modal-dialog');
			modal.draggable({
				handle: '.modal-header'
			});
			modal.on('dragstop', function (e, ui) {
				var positionTop = parseInt(e.currentTarget.style.top);
				(positionTop < 0) ? e.currentTarget.style.top = 0 : null;
			});

			loadingbar.stop();
		});
	},
	tooltips: function () {
		$('[data-tooltip]').each(function (i, el) {
			xdialog.tooltip.show($(el));
		});
	},
	elements: function () {
		var not = 'a:not([href^="mailto\\:"], [href^="javascript\\:\\;"], [href^="localexplorer\\:"], [href*=\\#], [target$="_blank"], [role="tab"], [download], [data-reload], .paginate_button)';

		$(document).off('click', not).on('click', not, function (event) {
			if (params.url === 'web' || web.lineage.includes('/components/')) return true; // web nevykdomas content load
			if (!$('#content').length) return true; // moduliai be #content (pvz. builder) - iprasta navigacija

			if ($(this).hasClass('xsearch')) {
				loadingbar.search();
				return;
			}
			/*
			if (params.url !== 'cweb') {
				loadingbar.start();
				return true;
			}
			*/
			event.preventDefault();
			xhelper.content.load(event.currentTarget.href);
		});

		$(".xpaginator .perpage select.simple").on("change", function (e) {
			var url = xhelper.url.setParam('paging', $(this).val());
			//nes gali nelikti to page, kuris buvo parinktas
			window.location.href = window.location.origin + window.location.pathname + url.replace(/(page=[^&]*)/g, "page=1");
		});

		$(document).on('click', 'button.xsearch', function (event) {
			loadingbar.search();
		});

		// nav active toggle
		$(document).off('click', '.nav-tabs a').on('click', '.nav-tabs a', function () {
			var clicked = $(this);

			clicked.closest('.nav-tabs').find('a').removeClass('active');
			clicked.addClass('active');
		});

		$('.xnav-modules li').on('click', function (e) {
			$('.xnav-modules li a').removeClass('active');
			$(this).find('a').addClass('active');
		});

		this.wizard();

		// moduliu navigacija
		$('.xnav-content a.xnav-link').click(function () {
			var el = $(this),
				title = el.data('title');

			if (!title) return;

			document.title = title;
		});
	},
	forms: function () {

		$('form:not(.xform)').each(function (e) {

			var form = $(this),
				initialState = false,
				buttons = form.find("button[type=submit]");


			if (form.attr('autocomplete') !== 'on') {
				form.attr('autocomplete', 'off');
			}

			form[0].initialState = initialState;

			form.on('keyup change paste', 'input, select, textarea, file', function () {
				form[0].initialState = true;
			});

			form.validate({
				onkeyup: false
			});

			buttons.each(function () {
				var btn = $(this);

				btn.on('click', function () {
					// safari netaiko focus ant button click, reikia forcinti del submit
					$(this).trigger('focus');
				});
			});

			let preventSubmit = false;
			form.on('submit', function (ev) {
				ev.preventDefault();
				if (preventSubmit) {
					return;
				}
				//debugger;
				if (form.valid() === false) {
					loadingbar.stop();
					return false;
				}

				var btn = form.find("button[type=submit]:focus");

				if (btn.length === 0) {
					btn = form.find("button[type=submit]");
				}

				if (btn.hasClass('xsearch')) {
					ev.currentTarget.submit();
					return true;
				}

				var config = {
					form: form,
					url: btn.data('url'),
					async: btn.data('async'),
					disablenotify: false
				},
					callback = btn.data('callback'),
					data = form.serialize(),
					submitUrl = btn.data('submit-url') || $(this).attr('action') /*this.action*/;



				if (btn.data('trigger') && !submitUrl) {
					submitUrl = '/json/save' + btn.data('trigger');
				}

				if (ev.isTrigger == 3) {
					callback = null;
					config.url = null;
					config.disablenotify = true;
				}

				const setPreventSubmit = (disabled) => {
					if (btn) {
						btn.prop('disabled', disabled);
					}
					preventSubmit = disabled;
				}

				const sendRequest = () => {
					setPreventSubmit(true);
					xcrud.json.save(submitUrl, data, callback, config, () => {
						setPreventSubmit(false);
					});
				}

				var performSubmit = () => {
					let fn = btn.data('before-submit');

					if (typeof window[fn] === 'function') {
						return window[fn](function (submit) {
							if (submit) {
								sendRequest();
							}
						});
					} else {
						sendRequest();
					}
				}

				if (btn.data('question')) {
					xdialog.question.show({
						title: btn.data('questionTitle'),
						text: btn.data('questionQuestion')
					}, function (confirm) {
						if (!confirm) return;
						performSubmit();
					});
				} else {
					performSubmit();
				}

			});

			form.addClass('xform');
		});
	},
	resolution: function (reload) {
		xcrud.json.send('/actions/resolution', {
			availHeight: screen.availHeight,
			availWidth: screen.availWidth,
			height: screen.height,
			width: screen.width,
			colorDepth: screen.colorDepth,
			pixelDepth: screen.pixelDepth
		}, function () {
			if (reload === true) {
				window.location.reload();
			}
		});
	},
	/**
	 * Form wizard events
	 */
	wizard: function () {
		var wizard = $('.wizard:not(.xlistener)');

		if (!wizard) return;

		wizard.addClass('xlistener');

		var submitBtn = wizard.find('button.wiz-save');

		// paraiskos pildymo metu leidziama issaugoti net neuzpildzius visu privalomu lauku
		if (wizard.data('required') === false) {
			var requiredFields = wizard.find('[required]');
			// nuimami required laukai
			requiredFields.each(function (_, input) {
				input.required = false
			});
		}

		wizard.on('change', ':input', function () {
			var form = $(this).closest('form');

			form.data('changed', true);
		});

		wizard.on('click', '.form-wizard-step-link, .wizard-btn-back', function (e) {
			e.preventDefault();
			var href = $(this).attr('href'),
				form = wizard.find('form');

			if (!form.data('changed')) {
				location.href = href;
				/* if (!form.valid()) {
					e.preventDefault();
					xdialog.question.show({
						title: 'Dėmesio',
						text: 'Yra neužpildytų privalomų laukų. Ar tikrai norite pereiti į kitą žingsnį?'
					}, function (confirm) {
						if (confirm) {
							location.href = href;
						}
					});
				} */

				return;
			}

			xdialog.question.show({
				title: 'Dėmesio',
				text: 'Yra neišsaugotų pakeitimų. Ar norite išsaugoti?',
				confirmButtonText: 'Išsaugoti',
				cancelButtonText: 'Ašaukti',
				showDenyButton: true,
				denyButtonText: `Nesaugoti`,
			}, function (_, answer) {
				if (answer.isDismissed) {
					// atsauke - liekama
					return;
				} else if (answer.isDenied) {
					// nesaugoti - eiti toliau
					location.href = href;
				} else {
					// saugoti ir eiti toliau
					submitBtn.data('url', href);
					submitBtn.trigger('click');
				}
			});

		});

		/* if (wizard.length > 0) {
			// dialogas pries iseinant is puslapio
			window.onbeforeunload = function (e) {
				return true;
			};
		} */
	}
};

var xlisteners = new x_listeners().init();